import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Button } from "react-bootstrap";
import { MdOutlineModeEditOutline, MdSupervisedUserCircle, MdAccountCircle } from "react-icons/md";

import Lead from "../../shared/Lead";
import * as API from "../../api";
import Loading from "../../shared/Loading";
import Select from "../../shared/Select";
import TextArea from "../../shared/TextArea";
import SelectAssignee from "./SelectAssignee";
import PriorityBadge from "../../shared/PriorityBadge";
import Patient from "../../shared/Patient";
import { Task, Settings } from "../../helpers/Contexts";

const OldGeneralPatientRequestForm = ({ task, dispatch, isCall, formHandler }) => {
  const settings = useContext(Settings);
  console.log("task", task);
  const [error, setError] = useState("");
  const [taskSubmitted, setTaskSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const TaskSchema = Yup.object().shape({
    priority: Yup.string().oneOf(["low", "medium", "high"]).nullable(),
    general_patient_request_status: Yup.string().required("Type is required."),
    preferred_contact_method: Yup.string()
      .required("Patient preferred contact method isrequired")
      .oneOf(["phone", "text", "email"]),
    notes: Yup.string().required("Notes is required"),
    assignee: Yup.string().required(
      "Assignee is required. Select a support group or agent to be assigned to this task."
    ),
  });

  return (
    <>
      <Formik
        initialValues={
          task.isNew || isCall
            ? {
                priority: "",
                general_patient_request_status: "",
                preferred_contact_method: "",
                assignee: "",
                assignee_id: "",
                assignee_support_group_id: "",
              }
            : {
                priority: task.priority,
                general_patient_request_status: task.general_patient_request_status,
                preferred_contact_method: task.preferred_contact_method,
                notes: task.notes,
                assignee: task.assignee.name,
              }
        }
        validateOnChange={true}
        validationSchema={TaskSchema}
        onSubmit={(values) => {
          setLoading(true);
          if (isCall) {
            formHandler({
              task: {
                task_type: "general_patient_request",
                status: "open",
                priority: values.priority,
                patient_id: task.patient.id,
                general_patient_request_status: values.general_patient_request_status,
                notes: values.notes,
                preferred_contact_method: values.preferred_contact_method,
                assignee_id: values.assignee_id && values.assignee_id,
                assignee_support_group_id:
                  values.assignee_support_group_id && values.assignee_support_group_id,
                assigner_id: settings.me.id,
                assigner_support_group_id: settings.me.support_group_id,
                id: task.id,
              },
            });
          } else {
            if (task.isNew) {
              API.postTask({
                task: {
                  task_type: "general_patient_request",
                  status: "open",
                  priority: values.priority,
                  patient_id: task.patient.id,
                  general_patient_request_status: values.general_patient_request_status,
                  notes: values.notes,
                  preferred_contact_method: values.preferred_contact_method,
                  assignee_id: values.assignee_id && values.assignee_id,
                  assignee_support_group_id:
                    values.assignee_support_group_id && values.assignee_support_group_id,
                  assigner_id: settings.me.id,
                  assigner_support_group_id: settings.me.support_group_id,
                },
              })
                .then((res) => {
                  setLoading(false);
                  dispatch({ type: "set_loading", payload: true });
                  history.push(`/physicians/tasks/item/${res.task.id}`);
                  setTaskSubmitted(true);
                })
                .catch((err) => {
                  console.log(err.data);
                  setError(err);
                });
            } else {
              task.formHandler({
                task: {
                  id: task.id,
                  priority: values.priority,
                  general_patient_request_status: values.general_patient_request_status,
                  notes: values.notes,
                  preferred_contact_method: values.preferred_contact_method,
                  assigner_id: settings.me.id,
                  assigner_support_group_id: settings.me.support_group_id,
                },
              });
            }
          }
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => {
          function renderForm() {
            return (
              <>
                <Select label="Priority" name="priority" value={values.priority}>
                  <option value="">{"Choose a priority level"}</option>
                  <option value={"low"}>Low</option>
                  <option value={"medium"}>Medium</option>
                  <option value={"high"}>High</option>
                </Select>

                <Select
                  label="Request Type/Topic"
                  value={values.general_patient_request_status}
                  name="general_patient_request_status"
                >
                  <option value={""}>{"Select the type of request"}</option>
                  {settings.general_patient_request_statuses.map((option, i) => (
                    <option className={"type"} key={i} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
                <TextArea
                  label="Notes"
                  value={values.notes}
                  name="notes"
                  placeholder="Please write additional notes"
                />
                <Select
                  label="Patient Preferred Contact Method"
                  name="preferred_contact_method"
                  value={values.preferred_contact_method}
                >
                  <option value={""}>{"Select patient preferred contact method"}</option>
                  <option value="text">{"Text"}</option>
                  <option value="phone">{"Phone"}</option>
                </Select>
              </>
            );
          }

          function renderFormVals() {
            return (
              <div>
                <label>
                  Priority
                  {values.priority && <PriorityBadge priority={values.priority} />}
                </label>

                <label>{"Request Type/Topic "}</label>
                {values.general_patient_request_status &&
                  values.general_patient_request_status.replaceAll("_", " ")}

                <label>Notes</label>
                {values.notes}

                <label>Patient Preferred Contact Method</label>
                {values.preferred_contact_method &&
                  values.preferred_contact_method.charAt(0).toUpperCase() +
                    values.preferred_contact_method.slice(1)}
              </div>
            );
          }

          function renderNewTaskForm() {
            return (
              <Form>
                <Row className="flex">
                  <Col md={5} className="pad20 form">
                    <Lead message={"New " + task.type} />
                    <br />
                    <br />
                    <SelectAssignee name="assignee" setFieldValue={setFieldValue} />
                    {renderForm()}
                    <button id="btn outline" type="submit" disabled={isSubmitting}>
                      Submit General Patient Request
                    </button>
                  </Col>
                  <Col md={7} className="pad20 border-container">
                    {loading && !taskSubmitted && <Loading message={"Creating Task "} />}
                    {error && <Lead message={"Error processing request"} />}

                    <Patient patient={{ ...task.patient }} />
                    <hr />

                    <label className="agent">
                      {"Assignee "}{" "}
                      <span id="from">
                        {values.assignee_id && values.assignee_support_group_id && (
                          <>
                            <MdAccountCircle className="task-agent" />
                            <b> {values.assignee}</b>
                          </>
                        )}

                        {!values.assignee_id && values.assignee_support_group_id && (
                          <>
                            {" "}
                            <MdSupervisedUserCircle className="task-agent" />
                            <b>{values.assignee} </b>
                          </>
                        )}
                      </span>
                    </label>
                    <hr />

                    <Lead message={task.type} />
                    <br />
                    <br />

                    {renderFormVals()}
                  </Col>
                </Row>
              </Form>
            );
          }

          function renderEditTaskForm() {
            const { taskValues, setTaskValues } = useContext(Task);

            return (
              <>
                {task.actions}
                <Col md={9} className="no-gutters task-cols">
                  {taskValues.editing.requested && (
                    <Col md={6} className="pad20">
                      <Form>
                        <MdOutlineModeEditOutline id="pencil-icon" />
                        <Lead message={"Editing General Patient Request"} />
                        <br />
                        <br />

                        {renderForm()}
                        <button id="btn outline" type="submit">
                          Submit General Patient Request
                        </button>
                      </Form>
                    </Col>
                  )}
                  <Col md={taskValues.editing.requested ? 6 : null} className={"pad20"}>
                    <Lead message={task.label} />
                    <br />
                    {new Date(task.created_at).toLocaleString([], {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                    <hr />
                    {renderFormVals()}
                  </Col>{" "}
                </Col>
              </>
            );
          }

          return (
            <>
              <Row className="flex">
                {(task.isNew || isCall) && renderNewTaskForm()}
                {!task.isNew && !isCall && renderEditTaskForm()}
              </Row>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default OldGeneralPatientRequestForm;
